<template>
  <div class="bg-black">
      <nav
        class="
        bg-black
        py-4
          container
          mx-auto
          md:flex md:justify-between md:items-center font-semibold
        "
      >
        <div class="flex items-center justify-between ">
          <router-link to="/">
          <img class="w-16 h-16" src="../assets/logo.png" alt="">
        </router-link>
            
          <!-- Mobile menu button -->
          <div @click="showMenu = !showMenu" class="flex md:hidden">
            <button
              type="button"
              class="
                text-gray-50
                hover:text-gray-400
                focus:outline-none focus:text-gray-400
              "
            >
              <svg viewBox="0 0 24 24" class="w-6 h-6 fill-current">
                <path
                  fill-rule="evenodd"
                  d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z"
                ></path>
              </svg>
            </button>
          </div>
        </div>


        <!-- Mobile Menu open: "block", Menu closed: "hidden" -->
        <ul
          :class="showMenu ? 'flex' : 'hidden'"
          class="
            flex-col
            mt-8
            space-y-4
            md:flex
            md:space-y-0
            md:flex-row
            md:items-center
            md:space-x-4
            md:mt-0
          "
        >
        <router-link
          to="/"
          class="text-left text-xl block py-2 pl-3 pr-4 lg:inline-block lg:mt-0 text-gray-50 hover:bg-black hover:text-slate-50 hover:ease-in duration-300 focus:underline focus:underline-offset-8 hover:underline hover:underline-offset-8 active:underline"
        style="font-family: Caveat;">
          {{$t("menu.home")}}
        </router-link>
        <router-link
          to="/aboutus"
          class="text-left text-xl block py-2 pl-3 pr-4 mt-4 lg:inline-block lg:mt-0 text-gray-50 hover:bg-black hover:text-slate-50 hover:ease-in duration-300 focus:underline focus:underline-offset-8 hover:underline hover:underline-offset-8 active:underline"
        style="font-family: Caveat;">
          {{ $t('menu.about') }}
        </router-link>
        <router-link
          to="/contact"
          class="text-left text-xl block py-2 pl-3 pr-4 mt-4 lg:inline-block lg:mt-0 text-gray-50 hover:bg-black hover:text-slate-50 hover:ease-in duration-300 focus:underline focus:underline-offset-8 hover:underline hover:underline-offset-8 active:underline"
        style="font-family: Caveat;">
          {{ $t('menu.contact') }}
        </router-link>
          <div class="md:order-2 text-left">
  
  <select  @change="changeLang($event)" v-model="lang" class="inline-flex items-center font-medium justify-center px-4 py-2 text-lg text-white rounded-lg cursor-pointer bg-black hover:bg-black hover:text-white hover:transition-all duration-500" style="font-family: Caveat;">
              <option value="mn" selected> 
  🇲🇳 Монгол (MN)</option>
              <option value="en">
  🇺🇸 English (US)</option>

  </select>
</div>
        </ul>
        
      </nav>
    </div>
</template>
<script>
export default {
  name: "Navigation",
 data(){
    return {
      showMenu: false,
      lang: "mn",
      $i18n: {
        locale: "mn",
      },
    }
  },
  methods: {
    toggleNav: function () {
        this.showMenu = !this.showMenu;
      },
    changeLang()
    {
      if (this.lang == "mn")
      {
        this.$i18n.locale = "mn";
      }
      if (this.lang == "en")
      {
        this.$i18n.locale = "en";
      }
     
    },
  }
};

</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;600;700;800;900&display=swap');
</style>